const Terms = () => import('./pages/Terms.vue');

export default [
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      title: 'Termos',
      public: true,
    },
  },
];
